import React from 'react'
import PropTypes from 'prop-types'
import { HrButtons, HrIconButton, HrPrimary } from '@components/styles/hr-styles'
import { HrButton } from '@components/button/button'

export const CancelButton = (props) => {
  return (
    <HrButtons
      type='button'
      category='cancel'
      size='large'
      onClick={() => {
        window.location.href = '/app/configuration/vacancy_request';
      }}
    >
      Cancelar
    </HrButtons>
  );
};

export const SaveDraftButton = (props) => {
  const { isSubmitting, submitDraft } = props;

  return (
    <HrButton
      type='button'
      category='tertiaryGray'
      size='large'
      onClick={submitDraft}
      text='Guardar borrador'
      disabled={isSubmitting}
    />
  );
};

export const BackNavigationButton = (props) => {
  const { onNavigateBack } = props;

  return (
    <HrButtons type='button' category='tertiaryGreen' size='large' onClick={onNavigateBack}>
      <HrIconButton className='hr-Carret-left' color={HrPrimary} />
      Anterior
    </HrButtons>
  );
};

export const NextNavigationButton = (props) => {
  const { onNavigateNext } = props;

  return (
    <HrButtons type='button' category='tertiaryGreen' size='large' onClick={onNavigateNext}>
      Siguiente
      <HrIconButton className='hr-Carret-right' color={HrPrimary} />
    </HrButtons>
  );
};

SaveDraftButton.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  submitDraft: PropTypes.func.isRequired
};

BackNavigationButton.propTypes = {
  onNavigateBack: PropTypes.func.isRequired
};

NextNavigationButton.propTypes = {
  onNavigateNext: PropTypes.func.isRequired
};
